const QuizShade = {
  QUIZ_ITEMS_COUNT: 8,
  currentIndex: 0,
  images: [
    { title: "default", value: "https://cdn.shopify.com/s/files/1/0572/1135/5320/files/quiz-shade--default.png?v=1741126606" },
    { title: "Classic", value: "https://cdn.shopify.com/s/files/1/0572/1135/5320/files/quiz-shade--Classic.png?v=1741126613" },
    { title: "Classic with a twist", value: "https://cdn.shopify.com/s/files/1/0572/1135/5320/files/quiz-shade--Classic_with_a_twist.png?v=1741126616" },
    { title: "Sophisticated", value: "https://cdn.shopify.com/s/files/1/0572/1135/5320/files/quiz-shade--Sophisticated.png?v=1741126621" }
  ],

  init() {
    const isShadeQuiz = document.querySelector('.quiz-shade__outer');
    if (!isShadeQuiz) return;

    document.querySelector('body').classList.add('quiz-shades-page');

    document.addEventListener("octane.quiz.questionLoaded", (event) => {
      this.currentIndex++;
      this.initObserver();
      this.setRightText(event.detail.question_title);
      this.setTitleSubtitle();
      this.addProgressBar();
      console.debug("octane.quiz.questionLoaded", event.detail);
    }, false);

    document.addEventListener("octane.quiz.completed", (event) => {
      this.setTitleSubtitle();
      document.querySelector('.quiz-shade__outer').classList.add('quiz-rezults');
      console.debug("octane.quiz.completed", event.detail);
    }, false);
  },

  setTitleSubtitle() {
    const title = document.querySelector(".oct-quiz-content > .oct-quiz-title").textContent;
    document.querySelector(".main-page-title").textContent = title;

    const subtitle = document.querySelector(".oct-quiz-content > .oct-quiz-subheading");
    const subtitleText = subtitle ? subtitle.textContent : '';
    document.querySelector(".main-page-subtitle").textContent = subtitleText;

    // Set current step progress
    switch(title) {
      case "Which skin colour tone do you have?": this.currentIndex = 0; break;
      case "What is your nail aesthetic?": this.currentIndex = 1; break;
      case "What colour family are you interested in?": this.currentIndex = 2; break;
      case "Which are your favourite colours in this range?": this.currentIndex = 3; break;
      case "What finish do you like on your nail gel?": this.currentIndex = 4; break;
      case "What is your style and skill level?": this.currentIndex = 5; break;
      case "Special offer":
        this.currentIndex = document.querySelector(".oct-quiz-wrapper--phone") ? 7 : 6;
        break;
      case "We've selected these shades specifically for you:": this.currentIndex = 6; break;
    }
  },

  getImageByTitle(title) {
    const foundItem = this.images.find(item => item.title === title);
    return foundItem ? foundItem.value : this.images[0].value;
  },

  setRightText(questionTitle) {
    // set right text
    const rightTextBlock = document.querySelector('.quiz-shade__right p');
    if (rightTextBlock) {
      rightTextBlock.textContent = questionTitle === "Special offer" ? 'Our squad' : 'Your pick';
    }

    // clear image
    document.querySelector(".quiz-shade__right div").style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0572/1135/5320/files/mylee-logo-with-bg.png?v=1742405331')";
  },

  addProgressBar() {
    const currentPercentage = parseInt((this.currentIndex / this.QUIZ_ITEMS_COUNT) * 100);
    const html = `<div class='quiz__progress-bar'><p>Completed: ${currentPercentage}%</p><span><span style='width: ${currentPercentage}%'></span></span></div>`;
    document.querySelector('.oct-quiz-btn-wrapper[data-element="oct-quiz-btn oct-quiz-submit-btn oct-quiz-media"]').insertAdjacentHTML("beforebegin", html);
  },

  handleMutation(mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' &&
        mutation.attributeName === 'data-is-option-selected' &&
        mutation.target.getAttribute('data-is-option-selected') === 'selected') {

        const target = mutation.target;
        const element = document.querySelector(".quiz-shade__right div");
        const imgDiv = target.querySelector('div[role="img"]');

        if (imgDiv) {
          element.style.backgroundImage = window.getComputedStyle(imgDiv).getPropertyValue('background-image');
        }

        console.debug(`Option changed:`, target);
      }
    }
  },

  initObserver() {
    document.querySelectorAll('.oct-quiz-picture-choice-options__option').forEach(element => {
      const observer = new MutationObserver(this.handleMutation.bind(this));
      observer.observe(element, {
        attributes: true,
        attributeFilter: ['data-is-option-selected'],
        subtree: false
      });
    });
  }
};

// Initialize the quiz
QuizShade.init();
